import React, { useReducer, useState, useEffect } from "react";
import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity, faCoffee, faCreditCard, faEnvelope, faHome, faPhone, faUser } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router-dom';



const formReducer = (state, event) => {
  return {
    ...state,
    [event.name]: event.value
  }
}


export default function CheckoutForm( props ) {

  function timeout(delay) {
    return new Promise( res => setTimeout(res, Number(delay)));
  }


  const [formData, setFormData] = useReducer(formReducer, {});

  const history = useHistory();

  const handleFinish = () => {
      history.push("/");
  }
  
  const handleFormChange = event => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  }

  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState('');
  // const [paymentId, setPaymentId] = useState('');

  const stripe = useStripe();
  const elements = useElements();

  var paymentId = '';

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    if (localStorage.getItem("id") === null) {
      localStorage.setItem("id", uuidv4())
    }

    let total = 0;
    Object.entries(props.products).map(([index, value]) => {
      total += value.price; 
    })

    let vv = {}

    vv['user'] = localStorage.getItem("id");
    vv['total'] = total;
    vv['email'] = formData.email;

    window
      .fetch("https://ggi-store.herokuapp.com/create-payment-intent", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({data: vv})
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        localStorage.setItem("paymentID", data.id);
        // paymentId = data.id;
        setClientSecret(data.clientSecret);
      });
  }, []);


  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  const handleSubmit = async ev => {

    ev.preventDefault();
    setProcessing(true);


    let vv = {}

    vv['user'] = localStorage.getItem("id");
    vv['total'] = Number(localStorage.getItem("total"));
    vv['cs'] = localStorage.getItem("paymentID");

    let cs_final = '';

    const a = await window
      .fetch("https://ggi-store.herokuapp.com/update-payment-intent", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({data: vv})
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        cs_final = data.clientSecret;
    });

    // alert(cs_final);


    const payload = await stripe.confirmCardPayment(cs_final, {
      receipt_email: formData.email.toString(),
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: formData.name,
          email: formData.email
        },
      }
    });

    if (payload.error) {
      setError(`Payment failed ${payload.error.message}`);
      setProcessing(false);
      alert(`Payment failed ${payload.error.message}`);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true);

      let stuff = {};
      Object.entries(formData).map(([name, value]) => (
        stuff[name] = value.toString()
      ))

      stuff['user'] = localStorage.getItem("id");

      // console.log(props.total);

      stuff['total'] = props.total;

      // console.log(stuff.toString());

      window
      .fetch("https://ggi-store.herokuapp.com/email", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({data: stuff})
      })
      .then(res => {
        return res.json();
      });

      await timeout(3500);

      history.push("/");

      window.location.reload();

    }


  };

  

  const cardStyle = {
    style: {
      base: {
        color: "#999",
        fontFamily: 'Sora',
        fontSize: "18px",
        "::placeholder": {
          color: "#999"
        },
        backgroundColor: 'white'
      },
      invalid: {
        color: "#C70039",
        iconColor: "#C70039",
        backgroundColor: 'white'
      }
    }
  };


  const inputs = document.querySelectorAll(".input");


  function addcl(){
    let parent = this.parentNode.parentNode;
    parent.classList.add("focus");
  }

  function remcl(){
    let parent = this.parentNode.parentNode;
    if(this.value === ""){
      parent.classList.remove("focus");
    }
  }


  inputs.forEach(input => {
    input.addEventListener("focus", addcl);
    input.addEventListener("blur", remcl);
  });



  return (
    <form onSubmit={handleSubmit}>
        <h2 class="title">Details</h2>
        <div id="n" class="input-div">
            <div class="i"> 
                <FontAwesomeIcon icon={faUser} />
            </div>
            <div class="div">
                <h5>Full Name</h5>
                <input onChange={handleFormChange} id="product" class="input" type="text" name="name" required />
            </div>
        </div>

        <div class="input-div">
            <div class="i"> 
                <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div class="div">
                <h5>Email</h5>
                <input  onChange={handleFormChange} class="input" type="text" name="email" required />
            </div>
        </div>

        <div class="input-div">
            <div class="i"> 
            <FontAwesomeIcon icon={faPhone} />
            </div>
            <div class="div">
                <h5>Phone Number</h5>
                <input  onChange={handleFormChange} class="input" type="number" name="phonenum" required />
            </div>
        </div>

        <div class="input-div">
            <div class="i"> 
                <FontAwesomeIcon icon={faHome} />
            </div>
            <div class="div">
                <h5>Address</h5>
                <input  onChange={handleFormChange} class="input" type="text" name="address" required />
            </div>
        </div>

        <div class="input-div">
            <div class="i"> 
                <FontAwesomeIcon icon={faHome} />
            </div>
            <div class="div">
                <h5>Zip</h5>
                <input  onChange={handleFormChange} class="input" id="img-input" type="number" name="zip" required/>
            </div>
        </div>

        <div class="input-div">
            <div class="i"> 
                <FontAwesomeIcon icon={faCity} />
            </div>
            <div class="div">
                <h5>City</h5>
                <input  onChange={handleFormChange} class="input" id="img-input" type="text" name="city" required/>
            </div>
        </div>

        <div id="cc" class="input-div">
            <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
        </div>


        <button className="btn" disabled={processing || disabled || succeeded} id="submit">
          
          { succeeded ? 
          (
            <span id="button-text">
              <svg aria-hidden="true" class="checkmark SVGInline-svg SVGInline--cleaned-svg SVG-svg Icon-svg Icon--check-svg Icon-color-svg Icon-color--white-svg" height="16" width="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.297 13.213L.293 8.255c-.39-.394-.39-1.033 0-1.426s1.024-.394 1.414 0l4.294 4.224 8.288-8.258c.39-.393 1.024-.393 1.414 0s.39 1.033 0 1.426L6.7 13.208a.994.994 0 0 1-1.402.005z" fill-rule="evenodd"></path></svg>
              Success
            </span>
          ) : (
            <span id="button-text">
              { processing ? (
                  <div className="spinner" id="spinner"></div>
                ) : (
                  "Pay"
                )}
            </span>
          )}

        </button>

        {/* <input type="submit" class="btn" value="Checkout" /> */}

        {/* <ul>
    {Object.entries(formData).map(([name, value]) => (
      <li key={name}><strong>{name}</strong>:{value.toString()}</li>
    ))}
    </ul> */}
            
    </form>


  );
}





